import http from "../http";

export const fetchPages = (storeId) =>
  http.get(`/store-management/pages/?store_id=${storeId}`);

export const fetchFullPage = (storeId, pageKey) =>
  http.get(
    `/store-management/full-page/?store_id=${storeId}&page_key=${pageKey}`,
  );
